<template>
  <div
    :data-testid="testId"
    :style="
      isLoading
        ? {}
        : {
            backgroundImage: `url('${src}')`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }
    "
    @click="emitClickEvent"
  >
    <slot></slot>
  </div>
</template>

<script>
import MediaSDK from '@/lib/ReverMediaSDK'

import defaultImage from '@/assets/images/placeholder-solid-color.svg'

export default {
  props: {
    mediaObject: {
      required: false,
      type: Object,
    },
    testId: {
      required: false,
      type: String,
      default: 'background-image',
    },
    defaultImage: {
      type: String,
      required: false,
      default: defaultImage,
    },
    size: {
      required: false,
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isLoading: false,
      src: this.defaultImage,
    }
  },

  watch: {
    mediaObject(newVal) {
      this.getPhoto(newVal)
    },
  },

  methods: {
    async getPhoto(mediaObject) {
      try {
        this.isLoading = true
        this.src = await MediaSDK.getImageSrc(mediaObject, this.size)
      } catch (err) {
        this.src = this.defaultImage
      } finally {
        this.isLoading = false
      }
    },

    emitClickEvent(e) {
      this.$emit('click', e)
    },
  },

  created() {
    this.getPhoto(this.mediaObject)
  },
}
</script>
